import { useEffect, useState } from "react";
import { subscribeToNewsletter } from "../../api";
import { logoWatermarkItems } from "../../data/logoWatermark";
import PrimaryButton from "../ui/PrimaryButton";

const NEWSLETTER_SUBSCRIBED_KEY = "mizu-newsletter-subscribed";

function NewsletterSection({ t, lang }) {
  const [status, setStatus] = useState("idle");
  const [email, setEmail] = useState("");

  useEffect(() => {
    try {
      if (localStorage.getItem(NEWSLETTER_SUBSCRIBED_KEY)) {
        setStatus("success");
      }
    } catch {
      /* ignore */
    }
  }, []);

  async function handleSubmit(event) {
    event.preventDefault();
    const value = email.trim();
    if (!value) return;

    setStatus("loading");

    try {
      await subscribeToNewsletter(value, lang);
      try {
        localStorage.setItem(NEWSLETTER_SUBSCRIBED_KEY, value);
      } catch {
        /* ignore */
      }
      setStatus("success");
    } catch {
      setStatus("error");
    }
  }

  function handleInvalid(event) {
    const input = event.currentTarget;
    if (input.validity.valueMissing) {
      input.setCustomValidity(t.requiredMessage);
    } else if (input.validity.typeMismatch) {
      input.setCustomValidity(t.invalidEmailMessage);
    } else {
      input.setCustomValidity("");
    }
  }

  function handleEmailChange(event) {
    event.currentTarget.setCustomValidity("");
    setEmail(event.target.value);
  }

  return (
    <section className="landing-section newsletter-section" id="newsletter">
      <div className="newsletter-logo-scatter" aria-hidden="true">
        {logoWatermarkItems.map((item, index) => (
          <img
            key={index}
            src="/img/mizulogo.png"
            alt=""
            className="newsletter-logo-scatter-item"
            style={{
              top: item.top,
              left: item.left,
              width: `${item.size}px`,
              transform: `translate(-50%, -50%) rotate(${item.rotate}deg)`,
            }}
          />
        ))}
      </div>

      <div className="container newsletter-section-inner">
        <div className="newsletter-copy">
          <p className="newsletter-eyebrow">{t.eyebrow}</p>
          <h2 className="newsletter-title">{t.title}</h2>
          <p className="newsletter-subtitle">{t.subtitle}</p>
        </div>

        <div className="newsletter-action">
          {status === "success" ? (
            <p className="newsletter-success" role="status">
              {t.success}
            </p>
          ) : (
            <form className="newsletter-form" onSubmit={handleSubmit} lang={lang}>
              <label
                className="visually-hidden"
                htmlFor="landing-newsletter-email"
              >
                {t.emailLabel}
              </label>
              <input
                id="landing-newsletter-email"
                type="email"
                name="email"
                required
                autoComplete="email"
                placeholder={t.emailPlaceholder}
                className="newsletter-input"
                value={email}
                onChange={handleEmailChange}
                onInvalid={handleInvalid}
                disabled={status === "loading"}
              />
              <PrimaryButton
                type="submit"
                className="newsletter-submit"
                disabled={status === "loading"}
              >
                {status === "loading" ? "..." : t.submit}
              </PrimaryButton>
              {status === "error" && (
                <p className="newsletter-error" role="alert">
                  {t.error}
                </p>
              )}
            </form>
          )}
        </div>
      </div>
    </section>
  );
}

export default NewsletterSection;
